/* eslint-disable linebreak-style */
/* eslint-disable quotes */
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from "react-router-dom";
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';
import { ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ListItemSelector from "../common/ListItemSelector";
import Checkbox from "../common/Checkbox";
import SelectInput from "../common/SelectInput";
import Input from "../common/Input";
import { ROLES } from "../common/Const";
import {
  getNormalizedSchoolYearStartYearFromSearch,
  pushManageRouteWithSchoolYear,
} from "./manageSchoolYearRouting";

const LessonModal = ({
  index,
  lesson,
  display,
  lessonDetailsEx,
  studentsEx,
  studentsNotInThisClassEx,
  teachers,
  students,
  onDateChange,
  weekdays,
  getDayOfWeek,
  getNameById,
  onAddStudent,
  onUndoChanges,
  onDetailsChange,
  onAttendanceChange,
  onSubmit,
  onDelete,
  showModal,
  showLessonDetailsMenu,
  showAddStudentMenu,
  setShowModal,
  setShowLessonDetailsMenu,
  setShowAddStudentMenu,
  showRemoveMode,
  setShowRemoveMode,
  onRemoveStudent,
  role,
  userTeacherId,
  canSubmit,
}) => {
  const canManageLessonDetails = role !== ROLES.TEACHER;
  const canEditAttendance = role !== ROLES.TEACHER || lessonDetailsEx.teacherId === userTeacherId;
  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowLessonDetailsMenu(false);
    setShowAddStudentMenu(false);
  };

  const history = useHistory();
  const location = useLocation();
  const activeSchoolYearStartYear = getNormalizedSchoolYearStartYearFromSearch(location.search);


  return (
    <>
      {display === "table" ? (
        <div className={`table-row row m-0 d-flex manage-text text-center cursor-pointer ${index % 2 !== 0 ? "table-row-alternate" : ""} ${lesson.lessonRegister ? "visible-border-left" : "transparent-border-left"}`}>
          <div className="col-10 col-sm-11">
            <div className="row d-flex align-items-center" onClick={handleShowModal}>
              <div className="col-sm-3 table-cell">{lessonDetailsEx.date}</div>
              <div className="col-sm-3 table-cell">{getDayOfWeek(lessonDetailsEx.dayOfWeek)}</div>
              <div className="col-sm-3 table-cell">{lessonDetailsEx.startTime}</div>
              <div className="col-sm-3 table-cell">{getNameById(teachers, lessonDetailsEx.teacherId)}</div>
            </div>
          </div>
          <div className="col-2 col-sm-1 p-0 d-flex align-items-center justify-content-center table-cell">
            {lessonDetailsEx.comment && (
              <OverlayTrigger overlay={<Tooltip>{lessonDetailsEx.comment}</Tooltip>}>
                <i className="fas fa-flag fa-lg" />
              </OverlayTrigger>
            )}
          </div>
        </div>
      ) : (
        <div className={`display-block w-100 cursor-pointer ${lesson.lessonRegister ? "dark-background" : "light-background"}`} onClick={handleShowModal}>
          {studentsEx.length === 0 ? (
            <div className="student-name-display-block empty-lesson-display-block">&nbsp;</div>
          ) : (
            studentsEx.map(student => (
              <div key={student.id} className="student-name-display-block">{getNameById(students, student.id)}</div>
            ))
          )}
        </div>
      )}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Body>
          
          <Button
            onClick={() => {
              setShowLessonDetailsMenu(!showLessonDetailsMenu);
              setShowAddStudentMenu(false);
            }}
            aria-expanded={showLessonDetailsMenu}
            className="col-12 mb-3"
            variant="outline-dark"
          >
              Zmień dane TYCH zajęć
          </Button>
          

          {canManageLessonDetails && lesson.defaultLessonDetails.isRecurring && (
            <Button
              onClick={() => {
                setShowLessonDetailsMenu(!showLessonDetailsMenu);
                setShowAddStudentMenu(false);
                setShowRemoveMode(false);
                const id = lesson.id;
                const cleanId = id.includes("-") ? id.substring(0, id.lastIndexOf("-")) : id;
                pushManageRouteWithSchoolYear(
                  history,
                  `/manage/class/${cleanId}`,
                  location.search,
                  activeSchoolYearStartYear,
                  { from: '/manage/' },
                );
              }}
              className="col-12 mb-3"
              variant="outline-primary"
            >
              Zmień dane WSZYSTKICH zajęć
            </Button>
          )}
          <Collapse in={showLessonDetailsMenu}>
            <div id="">
              <form id="group-form">
                {canManageLessonDetails && (
                  <div className="form-row">
                    <div className="col-sm-7 col-6">
                      <SelectInput
                        label="Dzień tygodnia"
                        name="dayOfWeek"
                        value={lessonDetailsEx.dayOfWeek}
                        defaultOption="Wybierz dzień tygodnia"
                        options={weekdays.map(d => ({
                          value: d.id,
                          text: d.name,
                        }))}
                        readOnly
                        onChange={() => {}}
                      />
                    </div>
                    <div className="col-sm-5 col-6">
                      <Input type="date" label="Data" onBlur={() => { }} onChange={e => onDateChange(e)} name="date" value={lessonDetailsEx.date} />
                    </div>
                  </div>
                )}
                {canManageLessonDetails && (
                  <div className="form-row">
                    <div className="col-sm-3 col-4">
                      <Input label="Godzina" onBlur={() => { }} type="time" onChange={onDetailsChange} name="startTime" value={lessonDetailsEx.startTime} placeholder="Początek zajęć" />
                    </div>
                    <div className="col-sm-9 col-8">
                      <SelectInput
                        label="Nauczyciel"
                        onBlur={() => { }}
                        onChange={onDetailsChange}
                        name="teacherId"
                        value={lessonDetailsEx.teacherId}
                        defaultOption="Wybierz nauczyciela"
                        options={teachers.map(t => ({
                          value: t.id,
                          text: `${t.firstName} ${t.lastName}`,
                        }))}
                      />
                    </div>
                  </div>
                )}
                <div className="form-row">
                  <div className="col-12">
                    <Input
                      label="Uwagi"
                      type="textarea"
                      onBlur={() => { }}
                      onChange={onDetailsChange}
                      name="comment"
                      value={lessonDetailsEx.comment}
                      placeholder="Uwagi"
                      readOnly={!canSubmit}
                    />
                  </div>
                </div>
                {canManageLessonDetails && (
                  <div className="form-row">
                    <div className="col-12">
                      <Checkbox
                        label="Nie naliczac za te lekcje / odwolana w terminie"
                        name="doNotCharge"
                        isChecked={!!lessonDetailsEx.doNotCharge}
                        onChange={onDetailsChange}
                        onBlur={() => {}}
                        textPosition="rightOnLarge"
                      />
                    </div>
                  </div>
                )}
              </form>
            </div>
          </Collapse>
          {canManageLessonDetails && (
          <>
            <Button
              onClick={() => {
                setShowAddStudentMenu(!showAddStudentMenu);
                setShowRemoveMode(false);
                setShowLessonDetailsMenu(false);
              }}
              aria-controls="student-list"
              aria-expanded={showAddStudentMenu}
              className="col-6 mb-3"
              variant="outline-success"
            >
              Dodaj ucznia
            </Button>
            <Button
              onClick={() => {
                setShowRemoveMode(prev => !prev);
                setShowAddStudentMenu(false);
                setShowLessonDetailsMenu(false);
              }}
              className="col-6 mb-3"
              variant="outline-danger"
            >
              {showRemoveMode ? "Wyłącz usuwanie" : "Usuń ucznia"}
            </Button>

          </>
          )}
          
          <Collapse in={showAddStudentMenu}>
            <div id="student-list">
              <ListItemSelector label="" onSelect={onAddStudent} options={studentsNotInThisClassEx} />
            </div>
          </Collapse>
          <div className="modal-title">Lista obecności</div>
          {/* <ListGroup className="row d-flex" variant="horizontal">
            {studentsEx.map(student => (
              <ListGroup.Item key={student.id} className="border-0 pb-0 col-sm-6">
                <div >
                  <Checkbox name="isPresent" label={getNameById(students, student.id)} onChange={e => onAttendanceChange({ ...e, studentId: student.id })} isChecked={student.isPresent} onBlur={() => { }} />
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup> */}
          
          <ListGroup className="row d-flex" variant="horizontal">
            {studentsEx.map(student => (
              <ListGroup.Item key={student.id} className="border-0 pb-0 col-sm-6 position-relative">
                <div>
                  <Checkbox
                    name="isPresent"
                    label={getNameById(students, student.id)}
                    onChange={e => onAttendanceChange({ ...e, studentId: student.id })}
                    isChecked={student.isPresent}
                    readOnly={!canEditAttendance}
                    onBlur={() => {}}
                  />
                  {canManageLessonDetails && showRemoveMode && (
                  <Button
                    variant="link"
                    className="text-danger p-0"
                    onClick={() => onRemoveStudent(student)}
                    style={{ position: 'absolute', fontSize: '1.7rem', top: '0.5rem', right: '0.5rem' }}
                  >
                    <i className="fas fa-times fa-lg" />
                  </Button>
                  )}
                </div>
              </ListGroup.Item>

            ))}
          </ListGroup>


        </Modal.Body>
        <Modal.Footer>
          {canManageLessonDetails && (
            <button type="button" className="btn manage-button btn-success mr-2" onClick={onUndoChanges}><i className="fas fa-undo" /></button>
          )}
          {canManageLessonDetails && (
            <button type="button" className="btn manage-button btn-dark mr-auto ml-0" onClick={onDelete}><i className="fas fa-trash-alt fa-lg" /></button>
          )}
          <div className="row d-flex">
            <button type="button" className="btn manage-button manage-teal-button mr-2" onClick={handleCloseModal}>Powrót</button>
            <button
              type="button"
              className="btn manage-button manage-red-button mr-2"
              onClick={onSubmit}
              disabled={!canSubmit}
            >
              Zapisz
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

LessonModal.propTypes = {
  lesson: PropTypes.object.isRequired,
  display: PropTypes.string.isRequired,
  lessonDetailsEx: PropTypes.object.isRequired,
  studentsEx: PropTypes.array.isRequired,
  studentsNotInThisClassEx: PropTypes.array.isRequired,
  teachers: PropTypes.array.isRequired,
  students: PropTypes.array.isRequired,
  onDateChange: PropTypes.func.isRequired,
  weekdays: PropTypes.array.isRequired,
  getDayOfWeek: PropTypes.func.isRequired,
  getNameById: PropTypes.func.isRequired,
  onAddStudent: PropTypes.func.isRequired,
  onUndoChanges: PropTypes.func.isRequired,
  onDetailsChange: PropTypes.func.isRequired,
  onAttendanceChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  showLessonDetailsMenu: PropTypes.bool.isRequired,
  showAddStudentMenu: PropTypes.bool.isRequired,
  showRemoveMode: PropTypes.bool.isRequired,
  setShowRemoveMode: PropTypes.func.isRequired,
  onRemoveStudent: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired,
  setShowLessonDetailsMenu: PropTypes.func.isRequired,
  setShowAddStudentMenu: PropTypes.func.isRequired,
  role: PropTypes.string,
  userTeacherId: PropTypes.string,
  canSubmit: PropTypes.bool,
};

LessonModal.defaultProps = {
  role: "",
  userTeacherId: "",
  canSubmit: true,
};

export default LessonModal;
